package ru.it_mozaika.sender.js.application.context

import io.ktor.client.call.*
import js.core.jso
import kotlinx.serialization.json.Json
import react.*
import ru.it_mozaika.sender.common.models.Category
import ru.it_mozaika.sender.js.application.Http

external interface CategoriesContextInterface{
    var categories: List<Category>
    var selected: List<Category>
    var selectedIds: List<String>
    var toggleId: (String) -> Unit
    var clearSelected: () -> Unit
    var getChildren: (String) -> List<Category>
}

val CategoriesContext = createContext<CategoriesContextInterface>(
    jso {
        categories = listOf()
        selected = listOf()
        selectedIds = listOf()
        toggleId = { }
        clearSelected = {}
        getChildren = {listOf()}
    }
)

val CategoriesProvider = FC<PropsWithChildren> { props ->
    val backDrop = useBackdrop()
    var categories by useState<List<Category>>(listOf())
    val (selected, setSelected) = useState<List<Category>>(listOf())
    val storeContext = useContext(StoreContext)
    val storage = kotlinx.browser.localStorage

    useEffect(categories) {
        if (categories.isNotEmpty()) {
            if (storage.getItem("selectedCategories") != null && storage.getItem("selectedCategories") != "") {
                val encodedString = storage.getItem("selectedCategories")
                val selectedCategories = try {
                    Json.decodeFromString<List<String>>(encodedString!!).mapNotNull { id ->
                        categories.find {
                            it.id == id
                        }
                    }
                } catch (e: Exception) {
                    listOf()
                }
                if (selectedCategories != selected) {
                    setSelected(selectedCategories)
                }
            }
        }
    }

    fun getCategories() {
        if (storeContext.currentStoreId != null) {
            backDrop.show()
            Http.get("/catalog/categories/list", query = mapOf("store" to storeContext.currentStoreId!!)) { response ->
                categories = response.body()
                backDrop.hide()
            }
        }
    }

    fun findAllChildren(id: String): MutableList<Category> {
        val list = categories.filter { it.parent == id }.toMutableList()
        if (list.isNotEmpty()) {
            list.addAll(list.flatMap {
                findAllChildren(it.id)
            })
        }
        return list
    }
    useEffect(storeContext.currentStore) {
        getCategories()
    }
    CategoriesContext.Provider {
        value = jso {
            this.categories = categories
            this.selected = selected
            this.selectedIds = selected.map { it.id }
            this.toggleId = { id ->
                if (!selected.map { it.id }.contains(id)) {
                    categories.find { it.id == id }?.let { category ->
                        setSelected { current ->
                            val result = current.toMutableSet()
                            result += category
                            result += findAllChildren(category.id)
                            var parent = categories.find { it.id == category.parent }
                            while (parent != null) {
                                val childItems = findAllChildren(parent.id)
                                if (result.containsAll(childItems)) {
                                    result += parent
                                    parent = categories.find {
                                        it.id == parent?.parent
                                    }
                                } else {
                                    parent = null
                                }
                            }
                            result.toList()
                        }
                    }
                } else {
                    categories.find { it.id == id }?.let { category ->
                        setSelected { current ->
                            val result = current.toMutableSet()
                            result -= category
                            result -= findAllChildren(category.id).toSet()
                            var parent = categories.find { it.id == category.parent }
                            while (parent != null) {
                                result -= parent!!
                                parent = categories.find {
                                    it.id == parent?.parent
                                }
                            }
                            result.toList()
                        }
                    }
                }
            }
            this.clearSelected = {
                setSelected(listOf())
            }
            this.getChildren = {
                findAllChildren(it)
            }
        }
        +props.children
    }
}